/**
 * React Query key factory — SIGNATURE keys (EPIC 19_SIGN).
 *
 * Référence centrale dans `queryKeys.ts` (barrel). SIGN-005 : la cérémonie
 * publique `/sign/:token` est no-auth — la clé est le jeton opaque de l'URL
 * (aucune PII, le reste est résolu côté serveur). SIGN-008 : le suivi est
 * scopé au PARENT (une ADB…) — invalidation après envoi/resend/relance/annulation.
 */

const signatureAll = ['signature'] as const

export const signatureKeys = {
    signature: {
        all: signatureAll,
        ceremony: (token: string) =>
            [...signatureAll, 'ceremony', token] as const,
        /** SIGN-008 — enveloppes d'un parent (une par version envoyée). */
        byParent: (parentId: string) =>
            [...signatureAll, 'byParent', parentId] as const,
        /** SIGN-008 — journal horodaté d'une enveloppe (timeline brute). */
        envelopeEvents: (envelopeId: string) =>
            [...signatureAll, 'envelopeEvents', envelopeId] as const,
        /** SIGN-009 — signabilité du document principal (garde d'entrée). */
        signableRoles: (parentId: string) =>
            [...signatureAll, 'signableRoles', parentId] as const,
    },
}
